














































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Api } from '@/service/api'

const BIU_MANAGER_HOST = process.env.VUE_APP_BIU_MANAGER_HOST as string
const LMS_MANAGER_HOST = process.env.VUE_APP_LMS_MANAGER_HOST as string

@Component
export default class App extends Vue {

  private menu_groups: any = null
  private my_info: any = null

  private async mounted () {

    const is_login = await Api.isLogin()
    if (!is_login) {
      return
    }

    const res: any = await Api.getMenu()
    this.menu_groups = res.data

    const res_my_info: any = await Api.getMyInfo()
    this.my_info = res_my_info.data

    this.$message.config({
      top: `60px`,
      duration: 2,
      maxCount: 3,
    })
  }

  private transMenuLink (url: string) {
    if (url.indexOf('http') >= 0) {
      return url
    }
    if (url.startsWith('^biu')) {
      url = url.replace('^biu', BIU_MANAGER_HOST)
      return url
    }
    return LMS_MANAGER_HOST + url
  }

  private logoutLink () {
    return LMS_MANAGER_HOST + '/logout'
  }

}
